import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import logo from "img/logo.svg";
import sfi from "img/logoSFI.png";
import {PolIcon} from "components/PolIcon/policon";
import {Link} from "react-router-dom";

export default function LoginModelPage({
                                           imageLeftRender,
                                           children,
                                           goBackTo,
                                           goBackOnClick,
                                       }) {
    const {t} = usePolTranslation();

    return (
        <main className={`loginpage bg-env-${process.env.REACT_APP_ENV}`}>
            <span className="round"/>
            <span className="round"/>
            <span className="round"/>

            <div className="row row-fluid justify-content-between login">

                <div className="col-12 col-lg-7 col-xl-8 login__images">
                    {goBackTo && (
                        <Link to={goBackTo}
                              onClick={goBackOnClick}
                              className="btn btn-primary login__images__back">
                            <PolIcon icon="arrow-left"/>
                            {t('retour')}
                        </Link>
                    )}

                    <div className="row justify-content-center align-items-center">
                        <div className="col-auto">
                            <img src={logo} className="login__images__logo" alt="POL CRM"/>
                        </div>
                        <div className="col-auto">
                            <p className="login__images__text">{t('pol_slogan')}</p>
                        </div>
                    </div>

                    <div className="login__images__presentation flex-fill d-none d-md-block">
                        {imageLeftRender && imageLeftRender()}
                    </div>
                </div>

                <div className="col-12 col-lg-5 col-xl-4 login__form">
                    <div className="row login__form__content">
                        <div className="col-12 align-self-center d-none d-sm-block">
                            <div className="row justify-content-end powered-by">
                                <div className="col-auto align-self-center">
                                    <p className="powered-by__text">{t('developpe_par')}</p>
                                </div>
                                <div className="col-auto">
                                    <img src={sfi} alt="Logo SFI"/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-8">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
